module.exports = __webpack_public_path__ + "img/gaokaoAi.279d3c48.gif";